<template>
  <div class="popup" v-if="isShowing">
    <div class="popup__block" @click.stop v-click-outside="close">
      <canvas class="qr-block" width="300" height="300" id="canvasQR"></canvas>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "PayOrderQrPopup",
  data() {
    return {
      isShowing: false,
      showQR: false,
    };
  },

  popupController: {},

  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },

  methods: {
    handleKeyDown(e) {
      if (this.isOpen && e.key === "Escape") {
        this.close();
      }
    },

    async open(url) {
      console.log(document.getElementById("canvasQR"));
      document.body.style.overflow = "hidden";
      this.isShowing = true;

      this.$nextTick(() => {
        QRCode.toCanvas(document.getElementById("canvasQR"), url, {
          width: 300,
          height: 300,
        });
      });

      return new Promise((resolve, reject) => {
        this.$options.popupController = { resolve, reject };
      });
    },
    close() {
      document.body.style.overflow = "auto";

      this.showQR = false;
      this.isShowing = false;
      this.$options.popupController.resolve(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 99;

  &__block {
    width: 340px;
    height: 340px;

    border-radius: 20px;
    background: #ffffff;
    padding: 20px;
  }
}

.qr-block {
  width: 300px;
  height: 300px;
}
</style>
